import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router";
import ProtectedRoutes from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";
import Login from "./pages/Login/Login";
import Register from "./pages/Register/Register";
import Menus from "./pages/Menus/Menus";
import Settings from "./pages/Settings/Settings";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import { Toaster } from "react-hot-toast";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import MenuEditor from "./pages/MenuEditor/MenuEditor";
import Languages from "./pages/Languages/Languages";
import QRCode from "./pages/QRCode/QRCode";
import AdditionalInfo from "./pages/AdditionalInfo/AdditionalInfo";
import Promotions from "./pages/Promotions/Promotions";
import Billing from "./pages/Billing/Billing";
import CategoryPage from "./pages/CategoryPage/CategoryPage";
import { useContext } from "react";
import { AuthContext } from "./context/auth-context";
import MenuOrder from "./pages/MenuOrder/MenuOrder";
import CategoryOrder from "./pages/CategoryOrder/CategoryOrder";
import NotFound from "./pages/NotFound/NotFound";

const App = () => {
  const authCtx = useContext(AuthContext);
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);

  if (authCtx.isLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <div>
      <Toaster />

      <Elements stripe={stripePromise}>
        <BrowserRouter>
          <Routes>
            <Route element={<ProtectedRoutes />}>
              <Route path="/" element={<Menus />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/:slug/menu-editor" element={<MenuEditor />} />
              <Route path="/:slug/menu-editor/*" element={<CategoryPage />} />
              <Route path="/:slug/menu-order" element={<MenuOrder />} />
              <Route path="/:slug/menu-order/*" element={<CategoryOrder />} />
              <Route path="/:slug/languages" element={<Languages />} />
              <Route path="/:slug/qr-code" element={<QRCode />} />
              <Route
                path="/:slug/additional-info"
                element={<AdditionalInfo />}
              />
              <Route path="/:slug/promotions" element={<Promotions />} />
              <Route path="/:slug/billing" element={<Billing />} />
              <Route path="/*" element={<NotFound />} />
            </Route>

            <Route element={<PublicRoutes />}>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </Elements>
    </div>
  );
};

export default App;
